/**
 * Shapes can be customized using the Material UI theming engine. In this example the lightMode theme is adjusted at several points to change the border radius of several shapes.
 * The modifications take place towards the bottom of the lightModeTheme object.
 *
 * Some useful links for working with themes can be found at:
 * https://themes.material-ui.com/
 * https://material-ui.com/customization/default-theme/ //Will show all the properties you can edit
 * https://material.io/resources/color/#!/?view.left=0&view.right=0&primary.color=c24f00&secondary.color=214563 //great for color selecting
 */

import { ThemeOptions } from '@material-ui/core';
import { AlmeTheme } from '../../../models/AlmeTheme';



const shape = {
    borderRadius: 24,
};

const lightModeTheme = { shape } as ThemeOptions;


export const appThemeMain = {
    lightTheme: lightModeTheme,
    darkTheme: {},
} as AlmeTheme;
